import { useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";
import { fetchHhExchangeNumbersLookups } from "../redux/thunks/fetchHHAExchangeNumbersLookups";
import { useAppDispatch } from "../redux/hooks";

type HhaExchangeItem = {
  ID: string;
  HomePhone?: string;
  Phone2?: string;
  Phone3?: string;
  RecordType?: "Caregiver" | "Patient";
};

export const useIntegrationLookups = () => {
  const dispatch = useAppDispatch();

  const fetchedCallerIDs = useRef<Set<string>>(new Set());
  const integrationsRef = useRef<RootState["integrations"]["items"]>([]);
  const hhaexchangeRef = useRef<HhaExchangeItem[]>([]);

  const integrations = useSelector((state: RootState) => state.integrations.items);
  const hhaexchange = useSelector((state: RootState) => state.hhaexchange.items);

  useEffect(() => {
    integrationsRef.current = integrations;
  }, [integrations]);

  useEffect(() => {
    hhaexchangeRef.current = hhaexchange;
  }, [hhaexchange]);

  const fetchIntegrationLookups = (number: string | string[] | null) => {
    if (!number || integrationsRef.current.length === 0) return;

    if (Array.isArray(number)) {
      const newNumbers = number.filter((num) => !fetchedCallerIDs.current.has(num));
      if (newNumbers.length === 0) return;

      newNumbers.forEach((num) => fetchedCallerIDs.current.add(num));

      const numbersToLookup = newNumbers.filter(
        (num) =>
          !hhaexchangeRef.current.find(
            (item) =>
              item.HomePhone === num ||
              item.Phone2 === num ||
              item.Phone3 === num
          )
      );

      if (numbersToLookup.length > 0) {
        dispatch(fetchHhExchangeNumbersLookups(numbersToLookup));
      }
    } else {
      if (fetchedCallerIDs.current.has(number)) return;
      fetchedCallerIDs.current.add(number);

      const exists = hhaexchangeRef.current.find(
        (item) =>
          item.HomePhone === number ||
          item.Phone2 === number ||
          item.Phone3 === number
      );

      if (!exists) {
        dispatch(fetchHhExchangeNumbersLookups(number));
      }
    }
  };

  return { fetchIntegrationLookups };
};
